interface NavIconProps {
  IconComponent: React.ElementType;
}

export const NavIcon = ({ IconComponent }: NavIconProps) => <IconComponent />;
